<template>
    <div class="modal course-modal" style="display: block">
        <div class="modal-dialog modal-dialog-centered modal-xl">
            <div class="modal-content p-2 p-md-4 p-lg-5">
                <div class="modal-body">
                    <button type="button" class="close-btn" @click="$emit('canceled')" aria-label="Close"
                            data-dismiss="modal"></button>

                    <div v-if="courseSchedules.length > 0" class="courses-list">
                        <h2>
                            <span class="text-muted">Available classes for</span>
                            {{ filter.from | dateFormat('dddd, D MMMM') }}
                            <span class="text-muted">/</span>
                            {{ startPeriod }} - {{ endPeriod }}
                        </h2>
                        <div class="alert alert-warning" v-for="warning in warnings">{{ warning }}</div>
                        <user-app-course-schedule-row :course-schedule="courseSchedule"
                                                      @select-course-schedule="selectCourseSchedule"
                                                      v-for="courseSchedule in courseSchedules" :key="courseSchedule.id"></user-app-course-schedule-row>

                    </div>
                    <div v-else>
                        <h2 class="text-danger">No available classes for
                            {{ filter.from | dateFormat('dddd, D MMMM') }}
                            <span class="text-muted">/</span>
                            {{ filter.from | dateFormat('ha') }} - {{ filter.till | dateFormat('ha') }}
                        </h2>
                        <div class="alert alert-warning">Nothing was found</div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>


<script>

export default {
    props: {
        courseSchedules: Array,
        booking: Object,
        filter: Object,
    },
    data() {
        return {
            selectedCourseSchedule: null,
            warnings: []
        };
    },
    mounted() {
        if (this.countOrdersAndWaitForDay() >= 2) {
            this.warnings.push('Guests may pre-book up to 2 classes per day, prior to arrival. Upon arriving on property, additional available classes may be added');
        }
    },
    methods: {
        selectCourseSchedule: function (courseSchedule) {
            this.selectedCourseSchedule = courseSchedule;
            this.$emit('select-course-schedule', {
                course_schedule_id: this.selectedCourseSchedule.id,
            })
        },
        countOrdersAndWaitForDay: function () {
            let selectedDate = this.filter.from.clone();
            let bookingStart = moment(this.booking.from);
            if (bookingStart.isBefore()) {
                return 0;
            }
            let orders = this.booking.orders;
            let waits = this.booking.waits;
            let sameDayOrders = [];
            for (let i = 0; i < orders.length; i++) {
                let orderStart = moment(orders[i].from);
                if (selectedDate.isSame(orderStart, 'date')) {
                    sameDayOrders.push(orders[i]);
                }
            }
            let sameDayWaits = [];
            for (let i = 0; i < waits.length; i++) {
                let orderStart = moment(waits[i].course_schedule.from);
                if (selectedDate.isSame(orderStart, 'date')) {
                    sameDayWaits.push(waits[i]);
                }
            }

            return sameDayOrders.length + sameDayWaits.length

        },


    },
    filters: {
        dateFormat: function (date, format) {
            return moment(date).format(format);
        }
    },
    computed: {
        startPeriod() {
            if (this.filter.from.minutes === 45) {
                let from = this.filter.from.clone().set(0, 'minutes').add(1, 'hour');
                return this.$options.filters.dateFormat(from, 'ha');
            }
            return this.$options.filters.dateFormat(this.filter.from, 'ha');
        },
        endPeriod() {
            if (this.filter.till.minutes === 15) {
                let till = this.filter.from.clone().set(0, 'minutes').subtract(1, 'hour');
                return this.$options.filters.dateFormat(till, 'ha');
            }
            return this.$options.filters.dateFormat(this.filter.till, 'ha');
        },
    }
}
</script>
